// extracted by mini-css-extract-plugin
export default {"details-container":"style_details-container__ffCh1","detail":"style_detail__hx7iS","label":"style_label__SkP8u","value":"style_value__qBhPV"};